import mixpanel from 'mixpanel-browser';

import api from './config/api';
import brand from '../core/config/brand';

import { getClientInfo, generateDeviceID } from './clientInfoService';
import { osName } from 'react-device-detect';

mixpanel.init(api.mixpanel.token, { ip: true });
const version = process.env.REACT_APP_VERSION ? process.env.REACT_APP_VERSION : '1.0';

export const publishPeoplePropsPreAuth = async () => {
  const uniqueId = localStorage.getItem('uniqueId')
    ? localStorage.getItem('uniqueId')
    : await generateDeviceID();
  mixpanel.identify(uniqueId);
  mixpanel.people.set({
    UniqueId: uniqueId,
    carrierId: brand.carrierId,
    AppName: brand.appName,
    AppVersion: version,
    browserName: getClientInfo().browserName,
    browserVersion: getClientInfo().browserVersion,
    OsVersion: getClientInfo().osVersion,
    AppVersionCode: '1.0',
    FormFactor: getClientInfo().device,
    OmniChannel: 'Web',
    DeviceVendor: getClientInfo().deviceVendor || osName,
    DeviceModel: getClientInfo().deviceModel || getClientInfo().device,
    DeviceLocale: getClientInfo().locale,
  });
};
